const FILES_BASE_URL = import.meta.env.VITE_FILES_BASE_URL || 'https://www.cabaza.be/files';

/**
 * La preuve sociale.
 *
 * NE PUBLIER QUE DES TEMOIGNAGES REELS ET CONSENTIS — directive 2005/29/CE
 * sur les pratiques commerciales déloyales, et RGPD art. 6.1.a pour le
 * consentement, qui reste révocable. Minimiser les données : un prénom et
 * une ville suffisent, ni nom complet ni adresse.
 *
 * Tant qu'il n'y a pas d'utilisateurs citables, le bloc existe mais reste
 * vide — et un bloc vide ne rend rien plutôt qu'un cadre creux.
 */
const TemoignagesBloc = ({ bloc }) => {
    const temoignages = Array.isArray(bloc?.temoignages) ? bloc.temoignages : [];
    const visibles = temoignages.filter(t => t?.texte);
    if (visibles.length === 0) return null;

    return (
        <section className="mb-10" data-testid="bloc-temoignages">
            {bloc.titre && (
                <h2 className="text-xl font-bold text-gray-900 mb-5">{bloc.titre}</h2>
            )}
            <div className="grid gap-4 sm:grid-cols-2">
                {visibles.map((t, i) => (
                    <figure key={i} className="rounded-xl border border-gray-200 bg-white p-5">
                        <blockquote className="text-sm text-gray-700 italic">
                            « {t.texte} »
                        </blockquote>
                        <figcaption className="mt-4 flex items-center gap-3">
                            {t.photo && (
                                <img
                                    src={`${FILES_BASE_URL}/${t.photo}`}
                                    alt=""
                                    loading="lazy"
                                    className="w-9 h-9 rounded-full object-cover"
                                />
                            )}
                            <div className="text-xs">
                                {t.auteur && (
                                    <p className="font-medium text-gray-900">{t.auteur}</p>
                                )}
                                {t.role && <p className="text-gray-500">{t.role}</p>}
                            </div>
                        </figcaption>
                    </figure>
                ))}
            </div>
        </section>
    );
};

export default TemoignagesBloc;
